import React from 'react';

import Radio from '@material-ui/core/Radio';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import { RadioItem, RadioLabel } from './AddTag.styles';

const Content = ({
  tags,
  actionValue,
  existingTagValue,
  newTagValue,
  onChange,
  classes,
}) => {
  return (
    <div>
      {!!tags.length && (
        <RadioItem>
          <Radio
            value="existing"
            label="Existing tag"
            name="actionValue"
            color="primary"
            checked={actionValue === 'existing'}
            onChange={onChange}
          />

          <RadioLabel>Existing tag</RadioLabel>

          <div>
            <Select
              value={existingTagValue}
              onChange={onChange}
              inputProps={{
                name: 'existingTagValue',
              }}
              MenuProps={{
                classes: { paper: classes.inputWidth },
              }}
              className={classes.inputWidth}
              disabled={actionValue !== 'existing'}
              autoWidth
            >
              {tags.map(tag => <MenuItem key={tag.id} value={tag.id}>{tag.name}</MenuItem>)}
            </Select>
          </div>
        </RadioItem>
      )}

      <RadioItem>
        <Radio
          value="new"
          label="Existing tag"
          name="actionValue"
          color="primary"
          checked={actionValue === 'new'}
          onChange={onChange}
        />

        <RadioLabel>New tag</RadioLabel>

        <TextField
          margin="normal"
          name="newTagValue"
          value={newTagValue}
          onChange={onChange}
          className={classes.inputWidth}
          disabled={actionValue !== 'new'}
        />
      </RadioItem>
    </div>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/AddTag/Content.jsx